module.exports = __webpack_public_path__ + "img/chevrons-right.78281712.svg";